import { useCurrentUser } from "../auth/useCurrentUser";
import "./UserAccount.scss";

function roleLabel(role: string) {
  return role.charAt(0).toUpperCase() + role.slice(1);
}

export function UserAccount() {
  const user = useCurrentUser();
  const username = user?.username ?? "Unknown user";
  const badge = username.slice(0, 2).toUpperCase();

  return (
    <>
      <span className="operator-badge">{badge}</span>
      <span className="operator-copy">
        <span className="operator-name">{username}</span>
        <span className="operator-role">
          {user ? roleLabel(user.role) : "Session unavailable"}
        </span>
      </span>
    </>
  );
}
